module.exports = __webpack_public_path__ + "img/32_28.7b77a061.png";